import React from 'react';
import UploadIcon from '@mui/icons-material/Upload';
import ListIcon from '@mui/icons-material/List';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LabelIcon from '@mui/icons-material/Label';
import CheckIcon from '@mui/icons-material/Check';
import ListAltIcon from '@mui/icons-material/ListAlt';

export interface NavItem {
  id: string;
  label: string;
  path?: string;
  icon: React.ComponentType;
  children?: NavItem[];
  dynamic?: boolean; // For contextual items like receipt details
}

export interface NavGroup {
  id: string;
  label: string;
  items: NavItem[];
}

export const navigationConfig: NavGroup[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    items: [
      {
        id: 'overview',
        label: 'Overview',
        path: '/',
        icon: AssessmentIcon,
      },
    ],
  },
  {
    id: 'receipts',
    label: 'Receipts',
    items: [
      {
        id: 'upload',
        label: 'Upload Receipt',
        path: '/upload',
        icon: UploadIcon,
      },
      {
        id: 'listReceipts',
        label: 'Receipts',
        path: '/receipts',
        icon: ListIcon,
      },
      {
        id: 'descriptions',
        label: 'Descriptions',
        path: '/descriptions',
        icon: LabelIcon,
      },
    ],
  },
  {
    id: 'lists',
    label: 'Lists',
    items: [
      {
        id: 'shoppingLists',
        label: 'Shopping Lists',
        path: '/lists',
        icon: ListAltIcon,
      },
      {
        id: 'completedLists',
        label: 'Completed Lists',
        path: '/lists/completed',
        icon: CheckIcon,
      },
    ],
  },
];
